import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from '@mui/material'
import React from 'react'
import bank from './BankList.json'
import OutlinedInput from '@mui/material/OutlinedInput'
import { useSelector } from 'react-redux'
import { ValidatorForm } from 'react-material-ui-form-validator'
const NetBanking = (props) => {
    const paymentData = useSelector((state) => state.customerData)

    const handleBack = () => {
        props.onBackBtnClick()
    }

    return (
        <div>
            <ValidatorForm onSubmit={props.onSubmit}>
                <Typography
                    style={{
                        padding: '10px 10px',
                    }}
                >
                    Choose your Bank
                </Typography>
                <FormControl sx={{ m: 1, width: '97%' }}>
                    <InputLabel
                        id="demo-multiple-name-label"
                        style={{
                            marginTop: '-10px',
                        }}
                    >
                        Choose a Bank
                    </InputLabel>
                    <Select
                        size="small"
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        value={props.bankName || ''}
                        onChange={props.handleBankList}
                        validators={['required']}
                        input={<OutlinedInput label="Choose a Bank" />}
                    >
                        {bank.map((name) => (
                            <MenuItem key={name.Id} value={name.Value}>
                                {name.Value}
                            </MenuItem>
                        ))}
                    </Select>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />

                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <button
                                onClick={handleBack}
                                className="backButton"
                                style={{
                                    width: '100%',
                                    padding: '15px',
                                    fontSize: '15px',
                                }}
                            >
                                Back
                            </button>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <button
                                type="submit"
                                className="btn"
                                style={{
                                    width: '100%',
                                    backgroundColor:
                                        paymentData.customerData.UIConfig
                                            .ButtonBackgroundColor,
                                    color: paymentData.customerData.UIConfig
                                        .ButtonTextColor,
                                }}
                            >
                                Pay
                            </button>
                        </Grid>
                    </Grid>
                </FormControl>
            </ValidatorForm>
            <div style={{ display: 'none' }}>
                <form
                    id="nonseamless"
                    action={props.state.RedirectUrl || ''}
                    method="POST"
                    name="redirect"
                >
                    <input
                        type="hidden"
                        name="encRequest"
                        id="encRequest"
                        value={props.state.StrEncRequest || ''}
                    />
                    <input
                        type="hidden"
                        name="access_code"
                        id="Hidden1"
                        value={props.state.AccessCode || ''}
                    />
                </form>
            </div>
        </div>
    )
}

export default NetBanking
